import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import {
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";

const DropdownActionsTable = ({ downloadMethod, params }) => {
  const dispatch = useDispatch();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleDownloadCSV = async () => {
    console.log("Download CSV");
    try {
      setDownloadLoading(true);
      await dispatch(downloadMethod(params)).unwrap();
    } catch (error) {
      console.log(error);
    } finally {
      setDownloadLoading(false);
    }
  };

  const toggleDropdown = () => setIsOpen(!isOpen);

  const renderDropdownMenu = () => {
    const portalRoot = document.getElementById("portal-root");
    return portalRoot
      ? ReactDOM.createPortal(
        <DropdownMenu>
          <DropdownItem
            onClick={(e) => {
              e.stopPropagation();
              handleDownloadCSV();
            }}
            className="edit-item-btn"
          >
            {downloadLoading ? (
              <Spinner size="sm" className="me-2" color="primary" />
            ) : (
              <i className="ri-download-2-fill align-bottom text-muted me-2"></i>
            )}
            Download CSV
          </DropdownItem>
        </DropdownMenu>,
        portalRoot
      )
      : null;
  };

  return (
    <ButtonGroup onClick={(e) => e.stopPropagation()}>
      <Dropdown
        isOpen={isOpen}
        toggle={toggleDropdown}
        className="dropdown d-inline-block ms-2"
      >
        <DropdownToggle tag="button" className="btn btn-soft-primary btn-sm">
          <i className="ri-more-fill align-middle"></i>
        </DropdownToggle>
        {renderDropdownMenu()}
      </Dropdown>
    </ButtonGroup>
  );
};

export default DropdownActionsTable;
